'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDisplayCurrencies = exports.getCurrencies = undefined;

var _currencies = require('tg-core-api/lib/currencies');

var _currencies2 = _interopRequireDefault(_currencies);

var _action = require('../../lib/action');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getCurrencies = exports.getCurrencies = function getCurrencies() {
  return (0, _action.makeApiCallAction)('GET_CURRENCIES', _currencies2.default.getCurrencies());
};
var getDisplayCurrencies = exports.getDisplayCurrencies = function getDisplayCurrencies() {
  return (0, _action.makeApiCallAction)('GET_DISPLAY_CURRENCIES', _currencies2.default.getDisplayCurrencies());
};

exports.default = {
  getCurrencies: getCurrencies,
  getDisplayCurrencies: getDisplayCurrencies
};